
export abstract class ProtocolDAO {
  abstract save(serverProtocol: string, date: string): void
  abstract get(): Promise<string[]>;

}
